import React from 'react'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import WatchLaterIcon from '@mui/icons-material/WatchLater'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const IconFromStatus = ({ status }: any) => {
    const theme = useTheme()
    const large = useMediaQuery(theme.breakpoints.up('sm'))

    switch (status) {
        case 'new':
            return (
                <AddCircleIcon
                    style={{
                        // @ts-expect-error TS(2339) FIXME: Property 'green' does not exist on type 'Palette'.
                        fill: theme.palette.green.main,
                        fontSize: large ? '20px' : '10px',
                        marginRight: large ? '5px' : '2px',
                    }}
                />
            )
        case 'pending':
            return (
                <WatchLaterIcon
                    style={{
                        fill: theme.palette.primary.main,
                        fontSize: large ? '20px' : '10px',
                        marginRight: large ? '5px' : '2px',
                    }}
                />
            )
        case 'refused':
            return (
                <RemoveCircleIcon
                    style={{
                        fill: theme.palette.error.main,
                        fontSize: large ? '20px' : '10px',
                        marginRight: large ? '5px' : '2px',
                    }}
                />
            )
        case 'active':
            return (
                <CheckCircleIcon
                    style={{
                        // @ts-expect-error TS(2339) FIXME: Property 'green' does not exist on type 'Palette'.
                        fill: theme.palette.green.main,
                        fontSize: large ? '20px' : '10px',
                        marginRight: large ? '5px' : '2px',
                    }}
                />
            )
        default:
            return null
    }
}

export default IconFromStatus
